import { Component, OnInit } from '@angular/core';
import { AngularFireStorage } from '@angular/fire/storage';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { GiftsService } from '../../serivce/gifts.service';
import { StudentsService } from '../../serivce/students.service';
import { finalize } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
export interface Array {

  value: string;
  viewValue: string;

}
@Component({
  selector: 'app-gifts-edit-dialog',
  templateUrl: './gifts-edit-dialog.component.html',
  styleUrls: ['./gifts-edit-dialog.component.css']
})
export class GiftsEditDialogComponent implements OnInit {
  dropdownStudent: Array[] = [];
  downloadURL: Observable<string>;
  model = {
    Title: '',
    Description: '',
    StudentId: 0
  }
  fb;
  result;
  constructor(
    private spinner: NgxSpinnerService,
    private studentsService: StudentsService,
    private giftsService: GiftsService,
    private toastr: ToastrService,
    private router: Router,
    private storage: AngularFireStorage,
    private route: ActivatedRoute) { }


  ngOnInit() {
    debugger
    this.model.Title = this.route.snapshot.params['Title']
    this.model.Description = (this.route.snapshot.params['Description'])
    this.model.StudentId = parseInt(this.route.snapshot.params['StudentId'])
    this.fb = (this.route.snapshot.params['Image'])
    this.loadStudents();
    if (this.fb == null || this.fb == "null") {
      $('#img').attr("src", "https://cdn.shopify.com/s/files/1/0358/0061/3001/products/SweetElegance_2_720x.png?v=1593020478");

    }
    else {
      $('#img').attr("src", this.fb);
    }

  }
  loadStudents() {
    this.studentsService.getListStudents().subscribe((res) => {
      this.result = res.data;
      this.dropdownStudent = [];
      for (var i = 0; i < this.result.length; i++) {
        var object = { value: this.result[i].id, viewValue: this.result[i].fullName };
        this.dropdownStudent.push(object);
      }
    });
  }
  Validate() {
    var ErrorCount = 0
    let regexp = new RegExp('^[0-9]{10}$');
    let regexpNumber = new RegExp('^[0-9]*$');
    if (this.model.Title == '') {
      this.toastr.warning("Chưa nhập tiêu đề quà tặng", "Thiếu dữ liệu");
      ErrorCount = ErrorCount + 1;
    }
    if (this.model.Description == '') {
      this.toastr.warning("Chưa nhập mô tả quà tặng", "Thiếu dữ liệu");
      ErrorCount = ErrorCount + 1;
    }
    if (this.model.StudentId == 0 || this.model.StudentId == null) {
      this.toastr.warning("Chưa chọn học viên", "Thiếu dữ liệu");
      ErrorCount = ErrorCount + 1;
    }

    if (ErrorCount == 0) {
      return true;
    }
    else return false;
  }
  onSubmit() {
    debugger
    if (this.Validate() == true) {
      var models = {
        Id: parseInt(this.route.snapshot.params['Id']),
        Title: this.model.Title,
        Description: this.model.Description,
        Image: this.fb,
        StudentId: this.model.StudentId
      }
      this.spinner.show();
      this.giftsService.editGift(models).subscribe(res => {
        this.spinner.hide();
        if (res.status == 2) {
          this.toastr.success(res.content, "Thành công");
          this.router.navigateByUrl('/gift');
        }
        else {
          this.toastr.error(res.content, "Thất bại");
        }
      })
    }

  }
  onFileSelected(event) {

    var n = Date.now();
    const file = event.target.files[0];
    const filePath = `RoomsImages/${n}`;
    const fileRef = this.storage.ref(filePath);
    const task = this.storage.upload(`RoomsImages/${n}`, file);
    task
      .snapshotChanges()
      .pipe(
        finalize(() => {
          this.downloadURL = fileRef.getDownloadURL();
          this.downloadURL.subscribe(url => {
            if (url) {
              this.fb = url;
              $('#img').attr("src", url);
            }

            console.log(this.fb);
          });
        })
      )
      .subscribe(url => {
        //if (url) {
        //  this.urls = url.toString();
        //  console.log(this.urls);
        //}
      });
  }
}
